<template>
    <BreadCrumb PageTitle="Ajouter un type un type de Document" />
    <AddModalTypeDocument />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddModalTypeDocument from "@/components/TypeDocument/AddModalTypeDocument.vue";


export default defineComponent({
    name: "AddTypeDocumentPage",
    components: {
        BreadCrumb,
        AddModalTypeDocument
    },
});
</script>